import Routes from '@/types/Routes';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import LandingPage from '@/views/LandingPage.vue';
import ResetPassword from '@/views/ResetPassword.vue';
import Register from '@/views/Register.vue';

import RegisterSmall from '@/views/RegisterSmall.vue';
import RegisterSmallLight from '@/views/RegisterSmallLight.vue';

import RegisterSuccessfull from '@/views/RegisterSuccessfull.vue';
import Management from '@/views/Management.vue';
import Reports from '@/views/Reports.vue';
import MailSender from '@/views/MailSender.vue';
import AccountManagement from '@/components/Management/Account/AccountManagement.vue';
import LicenseManagement from '@/components/Management/License/LicenseManagement.vue';
import ActivationManagement from '@/components/Management/Activations/ActivationManagement.vue';

import AccountsLog from '@/components/Reports/AccountsLog.vue';
import LicenseLog from '@/components/Reports/LicenseLog.vue';
import ActivationLog from '@/components/Reports/ActivationLog.vue';
import ErrorsLog from '@/components/Reports/ErrorsLog.vue';
import MailLog from '@/components/Reports/MailLog.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: Routes.root.path,
    name: Routes.root.name,
    component: LandingPage
  },
  {
    path: Routes.registerSuccessfull.path,
    name: Routes.registerSuccessfull.name,
    component: RegisterSuccessfull
  },
  {
    path: Routes.register.path,
    name: Routes.register.name,
    component: Register
  },

  {
    path: Routes.registerSmall.path,
    name: Routes.registerSmall.name,
    component: RegisterSmall
  },

  {
    path: Routes.registerSmallLight.path,
    name: Routes.registerSmallLight.name,
    component: RegisterSmallLight
  },

  {
    path: Routes.resetPassword.path,
    name: Routes.resetPassword.name,
    component: ResetPassword
  },
  {
    name: Routes.management.name,
    component: Management,
    path: Routes.management.accounts.path,

    children: [
      {
        path: '',
        name: `${Routes.management.name}|${Routes.management.accounts.name}`,
        component: AccountManagement
      },
      {
        path: Routes.management.licenses.path,
        name: `${Routes.management.name}|${Routes.management.licenses.name}`,
        component: LicenseManagement
      },
      {
        path: Routes.management.activations.path,
        name: `${Routes.management.name}|${Routes.management.activations.name}`,
        component: ActivationManagement
      }
    ]
  },

  {
    name: Routes.mailSender.name,
    path: Routes.mailSender.path,
    component: MailSender
  },

  {
    name: Routes.reports.name,
    component: Reports,
    path: Routes.reports.accountsLog.path,
    children: [
      {
        path: '',
        name: `${Routes.reports.name}|${Routes.reports.accountsLog.name}`,
        component: AccountsLog
      },
      {
        path: Routes.reports.licenseLog.path,
        name: `${Routes.reports.name}|${Routes.reports.licenseLog.name}`,
        component: LicenseLog
      },
      {
        path: Routes.reports.activationLog.path,
        name: `${Routes.reports.name}|${Routes.reports.activationLog.name}`,
        component: ActivationLog
      },
      {
        path: Routes.reports.errorsLog.path,
        name: `${Routes.reports.name}|${Routes.reports.errorsLog.name}`,
        component: ErrorsLog
      },
      {
        path: Routes.reports.mailLog.path,
        name: `${Routes.reports.name}|${Routes.reports.mailLog.name}`,
        component: MailLog
      }
    ]
  },

  {
    path: '/:catchAll(.*)',
    redirect: Routes.root.path
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
